import { v4 as uuidv4 } from "uuid";

export const uuid = () => {
  if (import.meta.env.MODE === "development") {
    // TODO: DELETE, ITS ONLY FOR TESTING
    return uuidv4();
  }
  return crypto.randomUUID();
};
